import { render, staticRenderFns } from "./ym-quota-page.vue?vue&type=template&id=acb08e88&scoped=true&"
import script from "./ym-quota-page.vue?vue&type=script&lang=js&"
export * from "./ym-quota-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb08e88",
  null
  
)

export default component.exports